module.exports = __webpack_public_path__ + "img/banner02LandPage.bcebd5d5.png";